import React from 'react';
import FileUpload from './FileUpload';
import FileList from './FileList';

function Sidebar({ isLoading, handleUpload, files, showPDF, handleDelete, currentPdfId }) {
  return (
    <div className="sidebar">
      <FileUpload isLoading={isLoading} handleUpload={handleUpload} />
      <FileList 
        files={files} 
        showPDF={showPDF} 
        handleDelete={handleDelete} 
        isLoading={isLoading}
        currentPdfId={currentPdfId}
      />
    </div>
  );
}

export default Sidebar; 